export default "/images/dce8d727132e874992e668354728a400.png";